export const ImageOrientation = (image) => {
  if (!image || !image.dimensions) return "landscape";
  const isImageLandscape = image.dimensions.width > image.dimensions.height;

  if (isImageLandscape === true) {
    return "landscape";
  } else {
    return "portrait";
  }
};
